import { RemoteUser } from "../../../../data/usecases/user/load-user";
import { User } from "../../../../domain/models/user";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteUser = (): User =>
  new RemoteUser("/me", makeAxiosHttpClient());

export const makeRemoteSuperDev = (): User =>
  new RemoteUser("/super-dev", makeAxiosHttpClient());
